export enum WorkflowDataEndpointMethods {
  Get = 'GET',
  Post = 'POST',
}
